export const gaTrackId = "UA-48270916-5";
export const gapiOAuthClientId =
  "769870583187-6p6tvl5nh7qc8m9hrgqh285siqm9oc37.apps.googleusercontent.com";
